import ViewRecommendedItems from 'src/pages/ViewRecommendedItems';
import { useContextSelector } from 'use-context-selector';
import ProductListView from './ProductListView';
import ProductPictureView from './ProductPictureView';
import { ViewCatalogProductsContext } from './ViewCatalogProductsContext';

const ToggleProductView = () => {
  const selectedView = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.selectedView
  );
  const isSwapItemModalOpen = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.isSwapItemModalOpen
  );
  const setIsSwapItemModalOpen = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.setIsSwapItemModalOpen
  );
  const swapItemData = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.swapItemData
  );

  return (
    <>
      <div
        className="flex h-full min-h-0 w-full flex-col overflow-hidden"
        style={{ gridArea: 'main' }}
      >
        {selectedView === 0 ? <ProductListView /> : <ProductPictureView />}
      </div>
      <ViewRecommendedItems
        isOpenSidePanel={isSwapItemModalOpen}
        onCloseSidePanel={() => setIsSwapItemModalOpen(false)}
        isInternal={true}
        dataParams={swapItemData}
      />
    </>
  );
};

export default ToggleProductView;
